document.addEventListener('DOMContentLoaded', function() {
    // Cache DOM elements
    const elements = {
        loadMoreButton: document.querySelector('[data-load-more]'),
        productList: document.querySelector('#product-list-main'),
        spinnerOverlay: document.querySelector('.collection__spinner-overlay'),
    };
    
    // Initialize state variables
    const state = {
        currentUrl: window.location.href,
        currentSortBy: new URLSearchParams(window.location.search).get('sort_by') || '',
        preloadedImages: new Map() // Store preloaded images
    };
    
    // Get load more container if button exists
    elements.loadMoreContainer = elements.loadMoreButton ? 
        elements.loadMoreButton.closest('[data-load-more-container]') : null;
    
  
    // Function to handle loading more products
    function handleLoadMore(e, button) {
        
        e.preventDefault();
        
        // Show loading spinner, hide button
        elements.spinnerOverlay.style.display = 'flex';
        button.style.display = 'none';
        
        // Store the current number of products before loading more
        const currentProductCount = elements.productList.querySelectorAll('product-card').length;
        
        // Fetch next page
        fetch(button.href)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                
                // Get products from the next page
                const newProductList = doc.querySelector('#product-list-main');
                
                // Remove any promotion elements from the new content before appending
                const promotionsInNewContent = newProductList.querySelectorAll('.collection-promotion');
                promotionsInNewContent.forEach(promo => promo.remove());
                
                // Append new products to the current product list
                elements.productList.innerHTML += newProductList.innerHTML;
                
                // Force a reflow to ensure the browser recognizes the new elements
                void elements.productList.offsetHeight;
                
                // Restore visibility for all products
                
                
                // Update the load more button URL to the next page
                const nextPageLink = doc.querySelector('[data-load-more]');
                if (nextPageLink) {
                    button.href = nextPageLink.href;
                    button.style.display = 'inline-block';
                } else {
                    // No more pages, hide the button container
                    const container = button.closest('[data-load-more-container]');
                    if (container) {
                        container.style.display = 'none';
                    }
                }
                
                // Update URL without page reload
                const url = new URL(window.location.href);
                if (state.currentSortBy) {
                    url.searchParams.set('sort_by', state.currentSortBy);
                }
                history.replaceState({}, '', url.toString());
                state.currentUrl = url.toString();
                

                // Hide spinner
                window.initColorSwatches;
                elements.spinnerOverlay.style.display = 'none';
            })
            .catch(error => {
                console.error('Error loading more products:', error);
                button.style.display = 'inline-block';
                elements.spinnerOverlay.style.display = 'none';
            });
    }
    
    // Initialize load more functionality
    if (elements.loadMoreButton && elements.productList) {
        elements.loadMoreButton.addEventListener('click', e => handleLoadMore(e, elements.loadMoreButton));
    }
    
});


///NOTE!!! Do a code review on this file and make sure it's not causing any issues with the collection page.